import { Directive, HostListener } from '@angular/core';
import { MatRadioGroup } from '@angular/material/radio';
import { FocusManagerService } from '@sc/feature-focus-manager';

@Directive({
  selector: 'mat-radio-group[preventDefaultArrow]',
  standalone: true,
})
export class MatRadioGroupArrowsDirective {
  constructor(
    private readonly matRadioGroup: MatRadioGroup,
    private readonly focusManagerService: FocusManagerService
  ) {}

  @HostListener('keydown.arrowdown', ['$event'])
  @HostListener('keydown.arrowright', ['$event'])
  onKeyDownOrRightHandler(event: KeyboardEvent) {
    event.preventDefault();
    const activeElementId = document.activeElement?.id;
    const idList = this.matRadioGroup._radios.map(
      (matRadioButton) => `${matRadioButton.id}-input`
    );

    const index = idList.findIndex((id) => id === activeElementId);
    const nextElementId =
      index === idList.length - 1 ? activeElementId : idList[index + 1];
    this.focusManagerService.focusFirstElementAllowed(
      `#${nextElementId}`,
      true
    );
  }

  @HostListener('keydown.arrowup', ['$event'])
  @HostListener('keydown.arrowleft', ['$event'])
  onKeyUpOrLeftHandler(event: KeyboardEvent) {
    event.preventDefault();
    const activeElementId = document.activeElement?.id;
    const idList = this.matRadioGroup._radios.map(
      (matRadioButton) => `${matRadioButton.id}-input`
    );

    const index = idList.findIndex((id) => id === activeElementId);
    const nextElementId = index === 0 ? activeElementId : idList[index - 1];
    this.focusManagerService.focusFirstElementAllowed(
      `#${nextElementId}`,
      true
    );
  }
}
